import { RunContextApp }                              from "framework/RCApp";
import { GetCMSPilots, 
         GetCMSPilotData, 
         CreateCMSPilot,
         GetCMSPilotStats,
         GetCMSSupportedLocales,
         GetCMSPilotCreationStatus,
         GetContentLimits
       }                                              from "types/apis/cmsPilotInterfaces";
import { CMSApiResponse }                             from "framework/http/CMSApiClient";
import { RecoScoreThreshold }                         from "features/recommendations/score/RecoScorePage";
import { GetRecoScore }                               from "types/apis/recoScoreInterfaces";

export const CMSPilotApis = {

  getPilots : async (rc : RunContextApp) : Promise<CMSApiResponse<GetCMSPilots.retval>> => {
    const resp = await rc.cmsApiClient.get<GetCMSPilots.retval>(`/utility/getUtilities`)
    return resp
  },

  getPilotData : async (rc : RunContextApp, utilityDocId : string) : Promise<CMSApiResponse<GetCMSPilotData.retval>> => {
    const resp = await rc.cmsApiClient.get<GetCMSPilotData.retval>(`/utility/getUtility?utilityDocumentId=${utilityDocId}`)
    return resp
  },

  getPilotDataByPilotId : async (rc : RunContextApp, pilotId : string) : Promise<CMSApiResponse<GetCMSPilotData.retval>> => {
    const resp = await rc.cmsApiClient.get<GetCMSPilotData.retval>(`/utility/getUtility?pilotId=${pilotId}`)
    return resp
  },

  getPilotStats : async (rc : RunContextApp, utilityDocId : string) : Promise<CMSApiResponse<GetCMSPilotStats.retval>> => {
    const resp = await rc.cmsApiClient.get<GetCMSPilotStats.retval>(`/utility/getUtilityStats?utilityDocumentId=${utilityDocId}`)
    return resp
  },

  getRecoScore : async (rc : RunContextApp, utilityDocId : string) : Promise<CMSApiResponse<GetRecoScore.retval>> => {
    const resp = await rc.cmsApiClient.get<GetRecoScore.retval>(`/utility/getRecoScoreMetadata?utilityDocumentId=${utilityDocId}`)
    return resp
  },

  updateRecoScore : async (rc : RunContextApp, recoScoreDocId : string, thresholds : Record<string, RecoScoreThreshold>) : Promise<CMSApiResponse<GetRecoScore.retval>> => {
    const resp = await rc.cmsApiClient.post<GetRecoScore.retval>(`/utility/updateRecoScoreMetadata`, {
      documentId : recoScoreDocId,
      thresholds : thresholds
    })
    return resp
  },

  createPilot : async (rc : RunContextApp, requestData : CreateCMSPilot.params) : Promise<CMSApiResponse<CreateCMSPilot.retval>> => {
    const resp = await rc.cmsApiClient.post<CreateCMSPilot.retval>(`/utility/createUtility`, {
      ...requestData
    })
    return resp
  },

  getPilotCreationStatus : async (rc : RunContextApp, jobId : string) : Promise<CMSApiResponse<GetCMSPilotCreationStatus.retval>> => {
    const resp = await rc.cmsApiClient.get<GetCMSPilotCreationStatus.retval>(`/utility/getUtilityCreationStatus?jobId=${jobId}`)
    return resp
  },

  getSupportedLocales : async (rc : RunContextApp) : Promise<CMSApiResponse<GetCMSSupportedLocales.retval>> => {
    const resp = await rc.cmsApiClient.get<GetCMSSupportedLocales.retval>(`/i18n/locales`)
    return resp
  },

  getContentLimits : async (rc : RunContextApp) : Promise<CMSApiResponse<GetContentLimits.retval>> => {
    const resp = await rc.cmsApiClient.get<GetContentLimits.retval>(`/content-limit`)
    return resp
  }
}